export default __webpack_public_path__ + "static/media/CNo.51-0.adaa31d5.jpg";